import {Injectable} from '@angular/core';
import {IziviaStorageService} from './storage/iziviaStorage.service';
import {Observable} from 'rxjs';
import {RELOAD_APP_TRACKER} from './storage/iziviaStorage.keys';
import moment from 'moment';
import {map, tap} from 'rxjs/operators';
import { switchTap } from '../utils/rxjsUtils';

/**
 * This service is designed to prevent from infinite reloading app which could lead to send too many HTTP requests to our server.
 *
 * It uses the storage service under the hood to store and limit the number of reloads.
 */
@Injectable({
    providedIn: 'root'
})
export class IziviaReloadPermissionService {
    constructor(private readonly storageService: IziviaStorageService) {
    }

    canReloadApp(): Observable<boolean> {
        return this.storageService.get(RELOAD_APP_TRACKER)
            .pipe(
                map((reloadAppTracker: ReloadAppTracker) => {
                    if (this.isStaleReloadAppTracker(reloadAppTracker)) {
                        reloadAppTracker = {
                            reloadAttempts: 0,
                            creationDate: new Date()
                        };
                    }

                    return reloadAppTracker;
                }),
                tap(reloadAppTracker => reloadAppTracker.reloadAttempts++),
                switchTap(reloadAppTracker => this.storageService.set(RELOAD_APP_TRACKER, reloadAppTracker)),
                map(reloadAppTracker => reloadAppTracker.reloadAttempts <= 3)
            );
    }

    private isStaleReloadAppTracker(reloadAppTracker: ReloadAppTracker): boolean {
        if (!reloadAppTracker) {
            return true;
        }

        return moment(reloadAppTracker.creationDate)
            .add(5, 'minute')
            .isBefore();
    }
}

interface ReloadAppTracker {
    reloadAttempts: number;
    creationDate: Date;
}
